export default "__VITE_ASSET__4lS$PRnr__"